
import LeaderboardStrategiesTableItem from './LeaderboardStrategiesTableItem.vue'

export default {
  components: { LeaderboardStrategiesTableItem },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      viewMore: false,
    }
  },
  computed: {
    topFiveRows() {
      const topFiveRows = this.blok.rows.slice(0, 5)

      return topFiveRows
    },
    restRows() {
      const restRows = this.blok.rows.slice(5)

      return restRows
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.viewMoreBtn) {
        this.initLoadMoreAnimation()
      }
    })
  },
  methods: {
    initLoadMoreAnimation() {
      const mm = this.$gsap.matchMedia(this.$refs.container)
      const viewMoreBtn = this.$refs.viewMoreBtn.$el.firstChild

      const tl = this.$gsap.timeline({
        paused: true,
      })
      // tl.from('.hidden-row', {
      //   display: 'none',
      //   duration: 0.1,
      // })
      tl.from('.hidden-row', {
        display: 'none',
        autoAlpha: 0,
        x: 40,
        stagger: 0.05,
        duration: 0.4,
        ease: 'back(.5)',
      })

      // add a media query. When it matches, the associated function will run
      mm.add('(min-width: 300px)', (context) => {
        context.add('onClick', () => {
          if (!this.viewMore) {
            tl.timeScale(1).play()
            this.viewMore = true
          } else {
            tl.timeScale(1.5).reverse()
            this.viewMore = false
          }
        })
        viewMoreBtn.addEventListener('click', context.onClick)

        return () => {
          // make sure to clean up event listeners in the cleanup function!
          viewMoreBtn.removeEventListener('click', context.onClick)
        }
      })
    },
  },
}
